import React, { FC, useState, useRef, useEffect } from "react";
import {
  Container,
  PaginationItem,
  SelectPageContainer,
  Rect,
  SelectPageInput,
  ItemWrapper,
} from './styles'
import { usePagination, DOTS } from "../../hooks/usePagination";
import Button from "../button";
import Arrow from './arrow.svg'
import { useQueryParam, NumberParam } from 'use-query-params';
type PagesProps = {
  changePage:(page:any) => void;
  currentPage:number;
  totalCount:number;
  pageSize:any;
  siblingCount:any
  customSetPage?:(page:any) => void
}

const Pages:FC<PagesProps> = (props) => {
  const [, setPage] = useQueryParam('page', NumberParam);
  
  const {
    changePage,
    currentPage,
    totalCount,
    pageSize,
    siblingCount,
    customSetPage
  } = props

  const updatePage = (nextPage:number) => {
    changePage(nextPage)
    if(customSetPage){
      customSetPage(nextPage)
    } else {
      setPage(nextPage)
    }
  }

  const paginationRange:any = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    updatePage(currentPage + 1)
  };

  const onPrevious = () => {
    updatePage(currentPage - 1)
  };

  const lastPage = paginationRange[paginationRange.length - 1]
  const edgeRange = lastPage > 7 && (currentPage <= 3 || currentPage >= lastPage - 2)
    ? [1, 2, 3, DOTS, lastPage - 2, lastPage - 1, lastPage]
    : paginationRange

  return (
    <Container aria-label="Pagination">
      
      <PaginationItem 
        type="button"
        $isArrow
        aria-label="Previous page"
        onClick={onPrevious}
        disabled={currentPage === 1}
      >
        <img alt="" src={Arrow}/>
      </PaginationItem>
      {edgeRange.map((pageNumber:any, index:any) => {
        if (pageNumber === DOTS) {
          return (
            <SelectPage key={`dots-${index}`} changePage={changePage} customSetPage={customSetPage}/>
          )
        }

        return (
          <PaginationItem 
              type="button"
              key={pageNumber}
              $active={pageNumber === currentPage}
              aria-current={pageNumber === currentPage ? 'page' : undefined}
              aria-label={`Page ${pageNumber}`}
              onClick={() => updatePage(pageNumber)}
            >
              {pageNumber}
            </PaginationItem>
        );
      })}
      <PaginationItem 
        type="button"
        $isArrow
        aria-label="Next page"
        onClick={onNext}
        disabled={lastPage === currentPage}
      >
        <img
        alt=""
        style={{transform:"rotate(180deg)"}}
        src={Arrow}/>
      </PaginationItem>
    </Container>
  )
}

export default Pages


const SelectPage:FC<any> = ({changePage, customSetPage}) => {
  const [showSelectPage, setShowSelectPage] = useState<boolean>(false)
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [value, setValue] = useState<any>(page ?? '')
  const optionsRef:any = useRef()
  const dropsRef:any = useRef()
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    },[]);

    const handleClickOutside = (event:any) => {
      if (!optionsRef.current?.contains(event.target) && !dropsRef.current?.contains(event.target)){
        setShowSelectPage(false)
      }
    }
    useEffect(() => {
      if (showSelectPage) {
        inputRef.current?.focus()
      }
    }, [showSelectPage])

    const goToPage = () => {
      const nextPage = Number(value)
      if (!Number.isInteger(nextPage) || nextPage < 1) {
        return
      }
      changePage(nextPage)
      if(customSetPage){
        customSetPage(nextPage)
      } else {
        setPage(nextPage)
      }
      setShowSelectPage(false)
    }
  return (
    <ItemWrapper>
      <SelectPageContainer
        ref={optionsRef}
        $active={showSelectPage}
        role="dialog"
        aria-label="Go to page"
        onSubmit={(event) => {
          event.preventDefault()
          goToPage()
        }}
      >
        {/* @ts-ignore */}
        <SelectPageInput
          type="number"
          ref={inputRef}
          aria-label="Page number"
          onChange={(e) => setValue(e.target.value)}
          placeholder="Number"
          value={value}
        />
        <Button 
          size='custom'
          customStyles={{width:'111px', height:"40px"}}
          variant='primary'
          onClick={goToPage}
          title='Go to page'
        />
        <Rect/>
      </SelectPageContainer>
      <PaginationItem 
        type="button"
        ref={dropsRef}
        aria-label="Choose a page"
        aria-expanded={showSelectPage}
        aria-haspopup="dialog"
        onClick={() => setShowSelectPage(!showSelectPage)}
      >
        ...
      </PaginationItem>
    </ItemWrapper>
  )
}
